/* [Trevenque] Mapa de tiendas (sections/tiendas-mapa.liquid).
 * Leaflet + teselas de OpenStreetMap (gratuito, sin clave). Datos: JSON de informax.locations
 * incrustado en la sección; las tarjetas ya vienen pintadas en Liquid y aquí solo se enlazan.
 */
(() => {
  if (customElements.get('tiendas-mapa')) return;

  const PIN = '<svg viewBox="0 0 24 34" aria-hidden="true"><path d="M12 1C5.9 1 1 5.9 1 12c0 8.3 11 21 11 21s11-12.7 11-21C23 5.9 18.1 1 12 1z"/><circle cx="12" cy="12" r="4"/></svg>';
  const normaliza = (s) => (s || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const escapa = (s) => (s == null ? '' : String(s)).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const km = (a, b) => {
    const R = 6371, r = Math.PI / 180;
    const dLat = (b[0] - a[0]) * r, dLng = (b[1] - a[1]) * r;
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(h));
  };

  class TiendasMapa extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      const arrancar = () => (window.L ? this.init() : setTimeout(arrancar, 50));
      arrancar();
    }

    init() {
      const L = window.L;
      this.tiendas = JSON.parse(this.querySelector('[data-tiendas]').textContent || '[]');
      this.cards = [...this.querySelectorAll('[data-tienda]')];
      this.lista = this.querySelector('[data-lista]');
      this.estado = this.querySelector('[data-estado]');
      this.vacio = this.querySelector('[data-vacio]');
      this.buscar = this.querySelector('[data-buscar]');
      this.provincia = this.querySelector('[data-provincia]');
      this.botonCerca = this.querySelector('[data-cerca]');
      this.zoomTienda = parseInt(this.dataset.zoomTienda, 10) || 16;
      this.textoRuta = this.dataset.boton || '';
      this.movil = window.matchMedia('(max-width: 989px)');

      this.mapa = L.map(this.querySelector('[data-mapa]'), {
        scrollWheelZoom: false,
        dragging: !L.Browser.mobile,
        tap: false,
      });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
      }).addTo(this.mapa);
      // La rueda del ratón solo hace zoom después de pinchar en el mapa (no atrapa el scroll de la página).
      this.mapa.on('click', () => this.mapa.scrollWheelZoom.enable());
      this.mapa.on('mouseout', () => this.mapa.scrollWheelZoom.disable());

      this.marcadores = this.tiendas.map((t, i) => {
        if (t.lat == null || t.lng == null) return null;
        const m = L.marker([t.lat, t.lng], {
          title: t.name,
          icon: L.divIcon({ className: 'tm-pin', html: PIN, iconSize: [28, 40], iconAnchor: [14, 40], popupAnchor: [0, -36] }),
        });
        m.bindPopup(() => this.popup(t));
        m.on('click', () => this.activar(i, { desdeMapa: true }));
        m.on('popupclose', () => this.desactivar(i));
        m.addTo(this.mapa);
        return m;
      });

      // Provincias del desplegable, sacadas de los datos.
      [...new Set(this.tiendas.map((t) => t.province).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b, 'es'))
        .forEach((p) => this.provincia.add(new Option(p, p)));

      this.cards.forEach((card) => {
        const i = +card.dataset.tienda;
        card.querySelector('[data-ver]')?.addEventListener('click', () => this.verEnMapa(i));
      });
      this.buscar.addEventListener('input', () => this.filtrar());
      this.provincia.addEventListener('change', () => this.filtrar());
      if ('geolocation' in navigator) {
        this.botonCerca.hidden = false;
        this.botonCerca.addEventListener('click', () => this.cercaDeMi());
      }

      this.encuadrar(this.visibles());
      new ResizeObserver(() => this.mapa.invalidateSize()).observe(this.querySelector('[data-mapa]'));
    }

    popup(t) {
      const lineas = [
        `<strong>${escapa(t.name)}</strong>`,
        `${escapa(t.address)}<br>${escapa(t.zip)} ${escapa(t.city)}`,
        t.phone ? `<a href="tel:${escapa(String(t.phone).replace(/[\s-]/g, ''))}">${escapa(t.phone)}</a>` : '',
        t.hours ? escapa(t.hours) : '',
        this.textoRuta ? `<a class="tm-ruta" href="https://www.google.com/maps/dir/?api=1&destination=${t.lat},${t.lng}" target="_blank" rel="noopener">${escapa(this.textoRuta)} →</a>` : '',
      ];
      return lineas.filter(Boolean).join('<br>');
    }

    visibles() {
      return this.cards.filter((c) => !c.hidden).map((c) => +c.dataset.tienda);
    }

    encuadrar(indices, extra) {
      const puntos = indices.map((i) => this.marcadores[i]).filter(Boolean).map((m) => m.getLatLng());
      if (extra) puntos.push(extra);
      if (!puntos.length) return;
      if (puntos.length === 1) this.mapa.setView(puntos[0], 14);
      else this.mapa.fitBounds(window.L.latLngBounds(puntos), { padding: [40, 40], maxZoom: 14 });
    }

    filtrar() {
      const q = normaliza(this.buscar.value);
      const prov = this.provincia.value;
      this.cards.forEach((card) => {
        const i = +card.dataset.tienda;
        const ok = (!q || normaliza(card.dataset.buscarEn).includes(q)) && (!prov || card.dataset.provincia === prov);
        card.hidden = !ok;
        const m = this.marcadores[i];
        if (m) ok ? m.addTo(this.mapa) : m.remove();
      });
      const n = this.visibles().length;
      this.estado.textContent = n === this.cards.length ? `${n} tiendas` : `${n} de ${this.cards.length} tiendas`;
      this.vacio.hidden = n > 0;
      this.encuadrar(this.visibles(), this.yo?.getLatLng());
    }

    activar(i, { desdeMapa = false } = {}) {
      this.cards.forEach((c) => c.classList.toggle('is-activa', +c.dataset.tienda === i));
      this.marcadores.forEach((m, j) => m?.getElement()?.classList.toggle('is-activa', j === i));
      // Al pinchar una chincheta, en escritorio se desplaza la lista (no la página) hasta su tarjeta.
      if (desdeMapa && !this.movil.matches) {
        const card = this.cards.find((c) => +c.dataset.tienda === i);
        if (card) this.lista.scrollTo({ top: card.offsetTop - this.lista.offsetTop - 8, behavior: 'smooth' });
      }
    }

    desactivar(i) {
      this.cards.find((c) => +c.dataset.tienda === i)?.classList.remove('is-activa');
      this.marcadores[i]?.getElement()?.classList.remove('is-activa');
    }

    verEnMapa(i) {
      const m = this.marcadores[i];
      if (!m) return;
      if (this.movil.matches) this.querySelector('[data-mapa]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      // El popup se abre al acabar el vuelo; si el mapa ya estaba ahí no hay moveend, de ahí el respaldo.
      let abierto = false;
      const abrir = () => { if (!abierto) { abierto = true; m.openPopup(); } };
      this.mapa.once('moveend', abrir);
      setTimeout(abrir, 1200);
      this.mapa.flyTo(m.getLatLng(), this.zoomTienda, { duration: 0.8 });
      this.activar(i);
    }

    cercaDeMi() {
      const texto = this.botonCerca.querySelector('.btn__text');
      const original = texto.textContent;
      texto.textContent = 'Buscando…';
      this.botonCerca.disabled = true;
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          texto.textContent = original;
          this.botonCerca.disabled = false;
          const yo = [pos.coords.latitude, pos.coords.longitude];
          if (this.yo) this.yo.setLatLng(yo);
          else this.yo = window.L.marker(yo, { icon: window.L.divIcon({ className: 'tm-yo', iconSize: [16, 16] }), title: 'Tu ubicación', zIndexOffset: 1000 }).addTo(this.mapa);

          // Ordena las tarjetas por distancia y muestra los km.
          const conDist = this.cards.map((card) => {
            const t = this.tiendas[+card.dataset.tienda];
            const d = t.lat != null ? km(yo, [t.lat, t.lng]) : Infinity;
            const el = card.querySelector('[data-distancia]');
            if (d !== Infinity) {
              el.textContent = d < 10 ? `${d.toFixed(1).replace('.', ',')} km` : `${Math.round(d)} km`;
              el.hidden = false;
            }
            return { card, d };
          });
          conDist.sort((a, b) => a.d - b.d).forEach(({ card }) => this.lista.appendChild(card));
          this.cards = conDist.map((x) => x.card);
          this.lista.scrollTo({ top: 0 });

          const cercanas = this.visibles().slice(0, 3);
          this.encuadrar(cercanas, this.yo.getLatLng());
          this.estado.textContent = 'Ordenadas por distancia a tu ubicación';
        },
        () => {
          texto.textContent = original;
          this.botonCerca.disabled = false;
          this.estado.textContent = 'No hemos podido obtener tu ubicación. Busca por ciudad o provincia.';
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
      );
    }
  }

  customElements.define('tiendas-mapa', TiendasMapa);
})();
